
export const questions = {
  "1, Introduction to Gerontology (Part 1)": [
    {
      id: 90001,
      question: "According to the required reading, which chapter of Darby & Walsh covers 'The Older Adult'?",
      options: [
        "Chapter 55",
        "Chapter 47",
        "Chapter 58",
        "Chapter 12"
      ],
      correctAnswer: 1
    },
    {
      id: 90002,
      question: "What is the main driver of the professional development need described for dental hygienists regarding the elderly population?",
      options: [
        "Demographic projections showing an increase in the elderly population",
        "A shortage of geriatric dentists nationwide",
        "New insurance billing codes for older adults",
        "A decline in dental school enrollment"
      ],
      correctAnswer: 0
    },
    {
      id: 90003,
      question: "What is identified as the primary cause of the significant demographic increase in the older adult population?",
      options: [
        "Higher birth rates among older adults",
        "Increases in life expectancy",
        "Reduced immigration of younger workers",
        "Improved dental insurance coverage"
      ],
      correctAnswer: 1
    },
    {
      id: 90004,
      question: "What term describes the generation shown as reaching older adulthood and driving demographic change in the slides?",
      options: [
        "Baby Boomers",
        "Generation X",
        "The Silent Generation",
        "Millennials"
      ],
      correctAnswer: 0
    },
    {
      id: 90005,
      question: "Regarding gender differences in the older adult population, which statement is accurate?",
      options: [
        "Elderly men outnumber elderly women and are more likely to be widowed",
        "Men and women are equally represented with similar widowhood rates",
        "Elderly men are more likely to live alone than elderly women",
        "Elderly women outnumber elderly men and are more likely to be widowed"
      ],
      correctAnswer: 3
    },
    {
      id: 90006,
      question: "Which term refers to the branch of medicine concerned with the illnesses of old age and their treatment?",
      options: [
        "Gerontology",
        "Functional age",
        "Geriatrics",
        "Chronologic age"
      ],
      correctAnswer: 2
    },
    {
      id: 90007,
      question: "Which term refers to the scientific study of the factors affecting the normal aging process and the effects of aging?",
      options: [
        "Geriatrics",
        "Gerontology",
        "Gerontologist",
        "Chronologic age"
      ],
      correctAnswer: 1
    },
    {
      id: 90008,
      question: "How is 'functional age' best defined based on the slide content?",
      options: [
        "Age based on performance capacities",
        "Age as measured by calendar time since birth",
        "Age determined by dental records",
        "Age estimated from bone density scans"
      ],
      correctAnswer: 0
    },
    {
      id: 90009,
      question: "How is 'chronologic age' best defined based on the slide content?",
      options: [
        "Age based on performance capacities",
        "Age based on self-reported health status",
        "Age as measured by calendar time since birth",
        "Age determined by cognitive testing"
      ],
      correctAnswer: 2
    },
    {
      id: 90010,
      question: "According to the slides, characterizations of age for healthcare purposes should be based primarily on what?",
      options: [
        "Functional ability rather than chronologic age",
        "Chronologic age rather than functional ability",
        "Insurance category rather than either age type",
        "Retirement status rather than either age type"
      ],
      correctAnswer: 0
    },
    {
      id: 90011,
      question: "Which three categories of theories are presented to explain why and how people age?",
      options: [
        "Nutritional theories, genetic theories, and economic theories",
        "Behavioral theories, dental theories, and environmental theories",
        "Social theories, physiologic aspects, and biologic theories",
        "Cognitive theories, hormonal theories, and cultural theories"
      ],
      correctAnswer: 2
    },
    {
      id: 90012,
      question: "In a functional health assessment, activities such as bathing, dressing, toileting, transferring, feeding, and continence are classified as what?",
      options: [
        "Instrumental activities of daily living (IADLs)",
        "Chronic condition indicators",
        "Activities of daily living (ADLs)",
        "Nutritional risk indicators"
      ],
      correctAnswer: 2
    },
    {
      id: 90013,
      question: "Using the phone, preparing meals, and managing money are examples of which category of functional assessment?",
      options: [
        "Activities of daily living (ADLs)",
        "Katz dependence scoring",
        "Oral hygiene aids",
        "Instrumental activities of daily living (IADLs)"
      ],
      correctAnswer: 3
    },
    {
      id: 90014,
      question: "In the Katz Index of Independence in Activities of Daily Living, what score indicates that a patient is fully independent?",
      options: [
        "A score of 0",
        "A score of 3",
        "A score of 10",
        "A score of 6"
      ],
      correctAnswer: 3
    },
    {
      id: 90015,
      question: "Which group of conditions is identified as the leading chronic conditions in older adults?",
      options: [
        "Arthritis, hypertension and heart disease, cancer, diabetes, and respiratory disorders",
        "Migraines, allergies, insomnia, anxiety, and skin conditions",
        "Hearing loss, vision loss, dental caries, gout, and anemia",
        "Osteoporosis, ulcers, thyroid disease, gallstones, and eczema"
      ],
      correctAnswer: 0
    },
    {
      id: 90016,
      question: "Per the Canadian data shown in the slides, approximately what percentage of Canadian seniors reported having one or more of the 11 listed chronic conditions?",
      options: [
        "About 40%",
        "About 55%",
        "About 95%",
        "About 76%"
      ],
      correctAnswer: 3
    },
    {
      id: 90017,
      question: "According to Healthy People 2030 findings referenced in the slides, how do older adults compare to the general population regarding health behaviors?",
      options: [
        "Older adults take worse care of their health than the general population does",
        "Older adults show no difference in health behaviors compared to the general population",
        "Older adults take better care of their health than the general population does",
        "Older adults report higher smoking rates than younger adults"
      ],
      correctAnswer: 2
    },
    {
      id: 90018,
      question: "Which dental/periodontal change in older adults involves cracks in the enamel surface?",
      options: [
        "Secondary dentin formation",
        "Pulp calcification",
        "Acquired lamellae",
        "Atrophic glossitis"
      ],
      correctAnswer: 2
    },
    {
      id: 90019,
      question: "Obturation in the dentinal tubules is a description of which age-related dental change?",
      options: [
        "Acquired lamellae",
        "Secondary dentin formation",
        "Pulp calcification",
        "Arrested caries"
      ],
      correctAnswer: 1
    },
    {
      id: 90020,
      question: "What has been the most significant change in older adults' oral status over the past century regarding tooth loss?",
      options: [
        "A decline in total tooth loss (edentulousness)",
        "A steady increase in total tooth loss (edentulousness)",
        "No measurable change in edentulousness rates",
        "A rise in tooth loss due to increased caries"
      ],
      correctAnswer: 0
    },
    {
      id: 90021,
      question: "According to the slides, does normal aging alone cause changes in the oral mucosa?",
      options: [
        "Yes, aging alone directly causes oral mucosal changes",
        "No, aging alone does not lead to changes in oral mucosa",
        "Yes, but only in male patients",
        "Yes, but only after age 90"
      ],
      correctAnswer: 1
    },
    {
      id: 90022,
      question: "A nutritional deficiency causing anemia can produce which tongue condition described in the slides?",
      options: [
        "Burning tongue syndrome",
        "Atrophic glossitis",
        "Sublingual varicosities",
        "Angular cheilitis"
      ],
      correctAnswer: 1
    },
    {
      id: 90023,
      question: "According to the slides, is a reduction in salivary flow a normal result of the aging process?",
      options: [
        "Yes, it is a normal and expected result of aging",
        "Yes, but only in edentulous patients",
        "No, it is not a result of the normal aging process",
        "Yes, but only in patients over 100 years old"
      ],
      correctAnswer: 2
    },
    {
      id: 90024,
      question: "Which condition described in the slides is an autoimmune disorder of the salivary glands involving dry oral mucosa and ropy saliva?",
      options: [
        "Atrophic glossitis",
        "Angular cheilitis",
        "Sjögren's syndrome",
        "Gingival hyperplasia"
      ],
      correctAnswer: 2
    },
    {
      id: 90025,
      question: "Which drugs are specifically named in the slides as potentially causing drug-induced gingival enlargement?",
      options: [
        "Phenytoin, nifedipine, and cyclosporine",
        "Ibuprofen, acetaminophen, and aspirin",
        "Amoxicillin, penicillin, and clindamycin",
        "Insulin, metformin, and warfarin"
      ],
      correctAnswer: 0
    },
    {
      id: 90026,
      question: "When positioning a client with mobility concerns in the dental hygiene process of care, where should the dental chair be positioned relative to the client's knees?",
      options: [
        "At the level of the client's knees or higher",
        "Below the level of the client's knees",
        "At the level of the client's shoulders",
        "It does not matter as long as the armrest is up"
      ],
      correctAnswer: 0
    },
    {
      id: 90027,
      question: "When communicating with an older adult client, who should the dental hygienist address directly according to the slides?",
      options: [
        "The family member or caregiver, rather than the client",
        "The older adult client, rather than the family member or caregiver",
        "Whoever answers first, regardless of role",
        "Only the client's physician"
      ],
      correctAnswer: 1
    },
    {
      id: 90028,
      question: "Why might scheduling short morning appointments be recommended for older adult clients?",
      options: [
        "Because older adults prefer evening appointments generally",
        "Because morning appointments require no medical history review",
        "Because insurance only reimburses morning visits",
        "Because factors such as arthritis may limit mouth opening and clients may tire more easily"
      ],
      correctAnswer: 3
    },
    {
      id: 90029,
      question: "Which of the following is listed among the conditions requiring alterations in dental hygiene care for older adults?",
      options: [
        "Common cold",
        "Seasonal allergies",
        "Mild dehydration",
        "Congestive heart failure"
      ],
      correctAnswer: 3
    },
    {
      id: 90030,
      question: "In the implementation phase of care for older adults, what change is recommended regarding maintenance therapy?",
      options: [
        "More frequent maintenance therapy with shorter appointments for quadrant scaling",
        "Less frequent maintenance therapy with longer full-mouth appointments",
        "Elimination of maintenance therapy after age 75",
        "Maintenance therapy only during hospital visits"
      ],
      correctAnswer: 0
    },
    {
      id: 90031,
      question: "What should be done for a client with hearing aids while the hygienist is using a handpiece?",
      options: [
        "Remove the hearing aids completely during treatment",
        "Increase the hearing aid volume to compensate for handpiece noise",
        "Keep the hearing aids in but reduce the volume",
        "Replace hearing aids with written notes only"
      ],
      correctAnswer: 2
    },
    {
      id: 90032,
      question: "Why is documentation described as critical in the evaluation phase of the dental hygiene process of care for older adults?",
      options: [
        "Because insurance requires it only for clients over 80",
        "Because documentation replaces the need for physician consultation",
        "Because it is only needed if the client is edentulous",
        "Because health status can change quickly and all care components depend on ongoing assessment"
      ],
      correctAnswer: 3
    },
    {
      id: 90033,
      question: "Which factor is listed as complicating the treatment of older adults in a traditional dental office setting?",
      options: [
        "Excessive availability of appointment times",
        "Accessibility of the dental office",
        "Overabundance of on-site staff",
        "Lack of any legal considerations"
      ],
      correctAnswer: 1
    },
    {
      id: 90034,
      question: "Which of the following is listed as an advantage of on-site dental programs for older adults?",
      options: [
        "Increases disruption from being transported",
        "Reduces anxiety by providing a familiar environment for clients",
        "Requires more travel time for clients",
        "Eliminates the need for any oral hygiene instruction"
      ],
      correctAnswer: 1
    },
    {
      id: 90035,
      question: "According to the nutritional risk data presented, which group of Canadian seniors is more likely to be at nutritional risk?",
      options: [
        "Men, and people without depression",
        "People living with large families",
        "People with high social participation",
        "Women, and people with depression"
      ],
      correctAnswer: 3
    },
    {
      id: 90036,
      question: "True or False: The health assessment of older persons should include a functional assessment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90037,
      question: "True or False: A gerontologist is defined as an individual who investigates numerous factors that affect the aging person and the aging process.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90038,
      question: "True or False: Dental hygienists should use large-print health and personal history forms or interview the client for relevant information when treating older adults.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90039,
      question: "True or False: Dental hygienists working with institutionalized and homebound elderly clients may provide in-service educational programs, such as marking dentures for identification and developing individual care plans.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "1, Introduction to Gerontology (Part 2)": [
    {
      id: 90040,
      question: "According to the fact sheet, what has allowed many seniors to keep their natural teeth longer?",
      options: [
        "Wearing full dentures earlier in life",
        "Proper oral hygiene",
        "Avoiding dental check-ups",
        "Using only over-the-counter mouth rinses"
      ],
      correctAnswer: 1
    },
    {
      id: 90041,
      question: "Even for those wearing full or partial dentures, what does the fact sheet say is still important?",
      options: [
        "Avoiding all dental visits",
        "Removing dentures permanently",
        "Switching to a liquid-only diet",
        "Having a clean mouth and regular check-ups"
      ],
      correctAnswer: 3
    },
    {
      id: 90042,
      question: "According to the fact sheet, periodontal disease has been linked to which group of serious health conditions?",
      options: [
        "Migraines, allergies, and skin rashes",
        "Heart disease, stroke, and respiratory disorders",
        "Vision loss, hearing loss, and hair loss",
        "Muscle cramps, insomnia, and anxiety"
      ],
      correctAnswer: 1
    },
    {
      id: 90043,
      question: "How does gum disease relate to diabetes according to the fact sheet?",
      options: [
        "Gum disease has no known relationship to diabetes",
        "Gum disease always cures diabetes symptoms",
        "Gum disease may worsen diabetes or increase its complications",
        "Gum disease only affects children with diabetes"
      ],
      correctAnswer: 2
    },
    {
      id: 90044,
      question: "Where do cavities in older adults appear most frequently, according to the fact sheet?",
      options: [
        "On the biting surfaces of the front teeth",
        "Only underneath existing crowns",
        "Exclusively on the tongue side of molars",
        "On the roots of the teeth at the gum line"
      ],
      correctAnswer: 3
    },
    {
      id: 90045,
      question: "What causes tooth or root decay according to the fact sheet?",
      options: [
        "Bacteria (plaque) that should be removed daily",
        "Cold weather exposure to the teeth",
        "Excessive use of fluoridated toothpaste",
        "Natural tooth whitening over time"
      ],
      correctAnswer: 0
    },
    {
      id: 90046,
      question: "What can years of brushing too hard, combined with natural aging, cause according to the fact sheet?",
      options: [
        "Teeth to become permanently whiter",
        "Enamel to thicken and strengthen",
        "Saliva production to increase significantly",
        "Gums to recede, exposing the roots of the teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 90047,
      question: "Which of the following is listed as a sign of periodontal disease in the fact sheet?",
      options: [
        "Swollen bleeding gums and loose or shifted teeth",
        "Perfectly white and stain-free teeth",
        "Increased tooth sensitivity to cold only",
        "A stronger sense of taste"
      ],
      correctAnswer: 0
    },
    {
      id: 90048,
      question: "What is dry mouth, as defined in the fact sheet?",
      options: [
        "An increase in saliva flow",
        "A decrease in saliva flow",
        "A buildup of plaque on the tongue",
        "A loss of taste sensation only"
      ],
      correctAnswer: 1
    },
    {
      id: 90049,
      question: "Which of the following is listed as a cause of dry mouth in the fact sheet?",
      options: [
        "Drinking too much water throughout the day",
        "Chewing sugarless gum regularly",
        "Medications for high blood pressure, heart problems, or depression",
        "Using fluoridated toothpaste twice daily"
      ],
      correctAnswer: 2
    },
    {
      id: 90050,
      question: "What can dry mouth lead to, according to the fact sheet?",
      options: [
        "A permanent improvement in taste",
        "A decrease in the need for dental visits",
        "Stronger tooth enamel over time",
        "An increase in decay and periodontal disease"
      ],
      correctAnswer: 3
    },
    {
      id: 90051,
      question: "Which of the following is recommended in the fact sheet to help relieve dry mouth?",
      options: [
        "Sip water throughout the day or chew sugarless gum",
        "Avoid drinking water as much as possible",
        "Use regular sugared candy for relief",
        "Stop brushing teeth until symptoms resolve"
      ],
      correctAnswer: 0
    },
    {
      id: 90052,
      question: "According to the treatment section, what should individuals discuss with a dental hygienist?",
      options: [
        "Only their preferred toothpaste flavor",
        "Only their insurance provider details",
        "Changes in health and any oral care concerns",
        "Only the color of their dentures"
      ],
      correctAnswer: 2
    },
    {
      id: 90053,
      question: "At what angle should the toothbrush be held to the teeth according to the fact sheet?",
      options: [
        "A 45 degree angle",
        "A 90 degree angle",
        "A 15 degree angle",
        "A 180 degree angle"
      ],
      correctAnswer: 0
    },
    {
      id: 90054,
      question: "How often does the fact sheet recommend flossing?",
      options: [
        "Once a week",
        "Only after every meal",
        "Once a day",
        "Twice a month"
      ],
      correctAnswer: 2
    },
    {
      id: 90055,
      question: "Which products does the fact sheet mention as options for cleaning larger spaces between teeth or massaging gums?",
      options: [
        "Metal toothpicks and steel wool pads",
        "Rubber tip stimulators, wooden dental picks, or small proxy brushes",
        "Cotton swabs and paper towels",
        "Ice cubes and lemon wedges"
      ],
      correctAnswer: 1
    },
    {
      id: 90056,
      question: "What does the fact sheet recommend regarding dental hygiene visits for seniors?",
      options: [
        "Decrease dental hygiene visits after retirement",
        "Stop dental hygiene visits once dentures are fitted",
        "Schedule dental hygiene visits only once every five years",
        "Increase dental hygiene visits and professional teeth cleaning"
      ],
      correctAnswer: 3
    },
    {
      id: 90057,
      question: "According to the fact sheet, dentures should be brushed using what?",
      options: [
        "Bleach and cold water",
        "Abrasive scouring powder",
        "Rubbing alcohol and a wire brush",
        "Warm water and mild soap or denture paste"
      ],
      correctAnswer: 3
    },
    {
      id: 90058,
      question: "Why does the fact sheet advise against using bleach to clean or soak dentures?",
      options: [
        "Because it makes dentures too shiny",
        "Because it can discolour and weaken them",
        "Because it is too expensive to use regularly",
        "Because it removes the denture's flavor coating"
      ],
      correctAnswer: 1
    },
    {
      id: 90059,
      question: "What should be done with dentures when they are not being worn, such as at night?",
      options: [
        "Leave them exposed to open air on a shelf",
        "Store them wrapped in a dry paper towel",
        "Soak them in water or a denture cleaning solution to prevent drying",
        "Place them directly in a freezer"
      ],
      correctAnswer: 2
    },
    {
      id: 90060,
      question: "According to the fact sheet, what is the average life span of dentures?",
      options: [
        "One to two years",
        "Five to seven years",
        "Fifteen to twenty years",
        "Twenty-five to thirty years"
      ],
      correctAnswer: 1
    },
    {
      id: 90061,
      question: "What material are dental implant posts made of, according to the fact sheet?",
      options: [
        "Titanium",
        "Stainless steel",
        "Aluminum",
        "Porcelain"
      ],
      correctAnswer: 0
    },
    {
      id: 90062,
      question: "Because a dental implant is not as strong as a natural tooth, what does the fact sheet recommend?",
      options: [
        "Brushing and flossing gently",
        "Brushing with a hard-bristled brush only",
        "Avoiding brushing the implant entirely",
        "Using bleach-based cleaners on the implant"
      ],
      correctAnswer: 0
    },
    {
      id: 90063,
      question: "Which signs should individuals watch for between professional oral cancer screenings, according to the fact sheet?",
      options: [
        "Red or white patches, sores that do not heal, or swelling",
        "Slightly whiter teeth after brushing",
        "A stronger sense of smell",
        "Improved gum firmness"
      ],
      correctAnswer: 0
    },
    {
      id: 90064,
      question: "In Ontario, dental hygienists are registered with which organization, according to the fact sheet?",
      options: [
        "The Canadian Dental Association only",
        "The Ontario Ministry of Finance",
        "The College of Dental Hygienists of Ontario",
        "The provincial pharmacy licensing board"
      ],
      correctAnswer: 2
    },
    {
      id: 90065,
      question: "True or False: The fact sheet states that dentures do not have to be a fact of life, since with proper oral hygiene many seniors keep their natural teeth longer.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90066,
      question: "True or False: According to the fact sheet, commercial denture cleaning solutions replace the need to brush dentures.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90067,
      question: "True or False: The fact sheet states that denture cleansers may be toxic if ingested and should not be gargled or swallowed.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "1, Introduction to Gerontology (Part 3)": [
    {
      id: 90068,
      question: "According to the material, what has been happening to the overall rate of people without teeth (edentulism)?",
      options: [
        "It has been increasing steadily",
        "It has been decreasing over time",
        "It has remained exactly the same",
        "It has fluctuated randomly each year"
      ],
      correctAnswer: 1
    },
    {
      id: 90069,
      question: "When should dentures typically be removed for a period of time each day?",
      options: [
        "Only during dental appointments",
        "Only while eating meals",
        "Usually at night while sleeping",
        "Only during physical exercise"
      ],
      correctAnswer: 2
    },
    {
      id: 90070,
      question: "What should dentures be cleaned with every day?",
      options: [
        "A regular toothbrush with whitening toothpaste",
        "Hot water and a stiff wire brush",
        "Alcohol-based mouthwash and a cloth",
        "A denture brush and non-abrasive denture cleanser or mild dishwashing soap"
      ],
      correctAnswer: 3
    },
    {
      id: 90071,
      question: "Why is it recommended to clean dentures over a folded towel or a sink filled with water?",
      options: [
        "To protect the dentures from breaking if they are accidentally dropped",
        "To keep the bathroom counter from getting wet",
        "To make the cleaning solution work faster",
        "To prevent water spots on the denture surface"
      ],
      correctAnswer: 0
    },
    {
      id: 90072,
      question: "Where should dentures be kept when they are not in the mouth?",
      options: [
        "Soaking in a container of water",
        "Wrapped in a dry paper towel",
        "Stored in a sealed plastic bag",
        "Left uncovered on a countertop"
      ],
      correctAnswer: 0
    },
    {
      id: 90073,
      question: "If a person still has natural teeth along with dentures, how should those natural teeth be cared for?",
      options: [
        "Brushed and flossed every day with the dentures removed from the mouth",
        "Brushed only once a week to avoid irritation",
        "Cleaned only by a dentist during checkups",
        "Brushed while the dentures remain in the mouth"
      ],
      correctAnswer: 0
    },
    {
      id: 90074,
      question: "What is true about the use of denture adhesives?",
      options: [
        "They should be used to glue in dentures that do not fit properly",
        "They should completely fill the space inside the denture",
        "They are recommended only for permanent dentures, not removable ones",
        "They can be used on well-fitting dentures but not to compensate for a poor fit"
      ],
      correctAnswer: 3
    },
    {
      id: 90075,
      question: "According to manufacturer guidance mentioned in the material, how much denture adhesive should generally be used?",
      options: [
        "As much cream as needed to fill the denture completely",
        "A thick layer applied twice per day for best results",
        "The smallest amount possible, such as a few pea-sized dabs or a thin layer of powder",
        "Only enough to last for several days without reapplying"
      ],
      correctAnswer: 2
    },
    {
      id: 90076,
      question: "Why is routine professional dental care important for denture wearers, including those with no natural teeth?",
      options: [
        "It has no real benefit once all natural teeth are gone",
        "It helps detect changes in denture fit and catch problems early for simpler treatment",
        "It is only needed if the dentures are visibly broken",
        "It is required solely for cosmetic whitening purposes"
      ],
      correctAnswer: 1
    },
    {
      id: 90077,
      question: "Individuals with no teeth should still see a dentist annually for an oral evaluation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "1, Introduction to Gerontology (Part 4)": [
    {
      id: 90078,
      question: "Which of the following is listed as a prevention measure for oral candidiasis in Box 61-9?",
      options: [
        "Keeping dentures in the mouth overnight",
        "Avoiding all oral hygiene products",
        "Removing dentures overnight",
        "Applying antifungal cream to healthy skin"
      ],
      correctAnswer: 2
    },
    {
      id: 90079,
      question: "What saline rinse concentration is recommended for prevention of oral candidiasis?",
      options: [
        "2 tablespoons of salt in 1 cup of water",
        "1 teaspoon of salt in 1 pint of water",
        "1/2 teaspoon of salt in 1 quart of water",
        "1/4 teaspoon of salt in 1 gallon of water"
      ],
      correctAnswer: 2
    },
    {
      id: 90080,
      question: "What is the recommended dosage and frequency for Nystatin oral suspension in first-route treatment?",
      options: [
        "200,000-500,000 IU, swished and swallowed 3-5 times a day",
        "10 mg, swished and swallowed once a day",
        "50-100 mg, swished only, for 7-14 days",
        "100-200 mg, swallowed twice weekly"
      ],
      correctAnswer: 0
    },
    {
      id: 90081,
      question: "How is frozen Nystatin suspension recommended to be administered?",
      options: [
        "Mixed into hot tea before swallowing",
        "Frozen in sugarless fruit juice",
        "Dissolved in carbonated soda",
        "Applied directly to the gums with a swab"
      ],
      correctAnswer: 1
    },
    {
      id: 90082,
      question: "What is the recommended dosage and duration for Clotrimazole troche in first-route treatment?",
      options: [
        "100 mg, once a day for 7 days",
        "10 mg, 5 times a day for 14 days",
        "5 mg, twice a day for 30 days",
        "50 mg, 3 times a day for 10 days"
      ],
      correctAnswer: 1
    },
    {
      id: 90083,
      question: "According to the first-route treatment guidance, how long should a patient avoid eating or drinking after topical antifungal treatment?",
      options: [
        "20 minutes",
        "2 hours",
        "5 minutes",
        "Until the next morning"
      ],
      correctAnswer: 0
    },
    {
      id: 90084,
      question: "Along with topical medication, what denture-related steps are part of first-route treatment?",
      options: [
        "Replacing the denture entirely every week",
        "Soaking the denture only once a month",
        "Discontinuing all denture care during treatment",
        "Using a new denture container and toothbrush, and treating the denture daily"
      ],
      correctAnswer: 3
    },
    {
      id: 90085,
      question: "Which systemic medication listed for second-route treatment may be given intravenously?",
      options: [
        "Fluconazole",
        "Amphotericin B",
        "Clotrimazole",
        "Nystatin"
      ],
      correctAnswer: 1
    },
    {
      id: 90086,
      question: "If oral candidiasis is not responding to treatment, what further lab tests may be needed?",
      options: [
        "Complete blood count only",
        "Chest X-ray and ECG",
        "Allergy skin testing",
        "Cytologic smear, culture, or biopsy"
      ],
      correctAnswer: 3
    },
    {
      id: 90087,
      question: "Continuing denture treatment and introducing new oral care products is recommended as part of second-route systemic treatment for oral candidiasis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "2. The Oral Cavity and Aging (Part 1)": [
    {
      id: 90088,
      question: "What is the clinical term for total tooth loss?",
      options: [
        "Xerostomia",
        "Edentulousness",
        "Cheilitis",
        "Hyperplasia"
      ],
      correctAnswer: 1
    },
    {
      id: 90089,
      question: "Approximately what proportion of adults aged 65 or older in the United States and Canada are edentulous?",
      options: [
        "One in ten",
        "One in five",
        "One in three",
        "One in two"
      ],
      correctAnswer: 1
    },
    {
      id: 90090,
      question: "Which of the following is NOT listed as a risk factor for tooth loss?",
      options: [
        "High socioeconomic status",
        "Poor daily oral hygiene",
        "Dental caries",
        "Periodontal diseases"
      ],
      correctAnswer: 0
    },
    {
      id: 90091,
      question: "Which psychologic factor is associated with tooth loss?",
      options: [
        "Greater social confidence",
        "Increased sexuality",
        "Improved self-esteem",
        "Fear of aging"
      ],
      correctAnswer: 3
    },
    {
      id: 90092,
      question: "Which of the following is a physiologic factor linked to becoming edentulous?",
      options: [
        "Enhanced taste perception",
        "Improved bone density",
        "Increased salivary flow",
        "Loss of orofacial muscle tone"
      ],
      correctAnswer: 3
    },
    {
      id: 90093,
      question: "Which condition contributes to residual ridge and alveolar bone resorption?",
      options: [
        "High-protein diet",
        "Fluoride varnish use",
        "Postmenopausal osteoporosis",
        "Frequent dental visits"
      ],
      correctAnswer: 2
    },
    {
      id: 90094,
      question: "What causes alveolar bone loss after tooth extraction according to the presented model?",
      options: [
        "Continuous chewing force",
        "Increased calcium intake",
        "Excess downward pressure on the alveolar bone",
        "Lack of downward pressure on the alveolar bone"
      ],
      correctAnswer: 3
    },
    {
      id: 90095,
      question: "Why are mandibular tori often removed before fabricating a removable partial denture (RPD)?",
      options: [
        "They increase salivary flow near the site",
        "They improve retention of the prosthesis",
        "The thin mucosa over them ulcerates easily under a connector",
        "They reduce plaque accumulation nearby"
      ],
      correctAnswer: 2
    },
    {
      id: 90096,
      question: "What instruments are used to remove bony tori?",
      options: [
        "Cotton pliers and floss",
        "Scalers and curettes",
        "Burrs and chisels",
        "Rubber cups and pumice"
      ],
      correctAnswer: 2
    },
    {
      id: 90097,
      question: "In fixed partial dental prostheses, what is the term for the tooth used to anchor the prosthesis and support the pontic?",
      options: [
        "Pontic",
        "Obturator",
        "Abutment",
        "Connector"
      ],
      correctAnswer: 2
    },
    {
      id: 90098,
      question: "In fixed partial dental prostheses, what is the term for the artificial tooth that occupies the edentulous space?",
      options: [
        "Abutment",
        "Retainer clasp",
        "Major connector",
        "Pontic"
      ],
      correctAnswer: 3
    },
    {
      id: 90099,
      question: "Which type of prosthesis replaces an entire arch of missing teeth with no remaining natural teeth?",
      options: [
        "Removable partial denture",
        "Complete denture",
        "Fixed partial denture",
        "Obturator"
      ],
      correctAnswer: 1
    },
    {
      id: 90100,
      question: "Which prosthesis uses retainer clasps and a major connector to attach to remaining natural teeth?",
      options: [
        "Fixed partial denture",
        "Removable partial denture",
        "Complete denture",
        "Obturator"
      ],
      correctAnswer: 1
    },
    {
      id: 90101,
      question: "A prosthesis used to close an oral defect, such as one resulting from surgery, is called what?",
      options: [
        "A complete denture",
        "An abutment",
        "A pontic",
        "An obturator"
      ],
      correctAnswer: 3
    },
    {
      id: 90102,
      question: "In the removable partial denture clasp image, what problem was noted at the gingival third of the abutment tooth?",
      options: [
        "Retained plaque biofilm under the clasp",
        "Gingival recession only",
        "Enamel hypoplasia",
        "Root fracture"
      ],
      correctAnswer: 0
    },
    {
      id: 90103,
      question: "Which of the following is NOT listed as a challenge associated with replacing missing teeth?",
      options: [
        "Speech disturbances",
        "Reduced masticatory efficiency",
        "Improved masticatory efficiency without adjustment",
        "Physical appearance changes"
      ],
      correctAnswer: 2
    },
    {
      id: 90104,
      question: "What happens to facial proportions when missing teeth are not replaced, according to the facial contour comparison?",
      options: [
        "Facial height increases dramatically",
        "Bite collapse occurs and lip/cheek support is lost",
        "Lip support improves",
        "Wrinkles are reduced"
      ],
      correctAnswer: 1
    },
    {
      id: 90105,
      question: "Which of the following is a factor affecting the oral mucosa of denture-wearing individuals?",
      options: [
        "Increased salivary flow",
        "Improved bone density",
        "Reduced denture wear time",
        "Xerostomia"
      ],
      correctAnswer: 3
    },
    {
      id: 90106,
      question: "Which autoimmune condition is specifically listed as a cause of xerostomia?",
      options: [
        "Sjogren's syndrome",
        "Hashimoto's thyroiditis",
        "Type 1 diabetes",
        "Rheumatoid arthritis"
      ],
      correctAnswer: 0
    },
    {
      id: 90107,
      question: "Which of the following is listed as a factor associated with xerostomia?",
      options: [
        "Improved hormonal balance",
        "Increased fluid balance",
        "Polyuric states",
        "Reduced medication use"
      ],
      correctAnswer: 2
    },
    {
      id: 90108,
      question: "What is the recommended oral pilocarpine dose for radiation-induced xerostomia?",
      options: [
        "5 to 10 mg three times daily",
        "1 to 2 mg once daily",
        "20 mg twice daily",
        "50 mg once weekly"
      ],
      correctAnswer: 0
    },
    {
      id: 90109,
      question: "What is the recommended oral pilocarpine dose for xerostomia associated with Sjogren's syndrome?",
      options: [
        "2 mg six times daily",
        "10 mg once daily",
        "15 mg twice daily",
        "5 mg four times daily"
      ],
      correctAnswer: 3
    },
    {
      id: 90110,
      question: "How long do the effects of oral pilocarpine typically last?",
      options: [
        "Twelve hours",
        "Three to five hours",
        "Thirty minutes",
        "One full day"
      ],
      correctAnswer: 1
    },
    {
      id: 90111,
      question: "Which of the following is part of dental hygiene care for clients with removable prostheses?",
      options: [
        "Recommending continuous nonstop wear",
        "Ignoring mucosa irritations",
        "Assessing occlusion and fit",
        "Avoiding oral hygiene instruction"
      ],
      correctAnswer: 2
    },
    {
      id: 90112,
      question: "Mucosal conditions related to dentures are generally categorized into which groups?",
      options: [
        "Reactive/traumatic, infectious, and mixed",
        "Vascular, endocrine, and metabolic",
        "Allergic, neoplastic, and idiopathic",
        "Viral, genetic, and congenital"
      ],
      correctAnswer: 0
    },
    {
      id: 90113,
      question: "A reactive lesion characterized by folds of excess tissue caused by an ill-fitting denture flange is called what?",
      options: [
        "Chronic candidiasis",
        "Fibrous hyperplasia only",
        "Angular cheilitis",
        "Epulis fissuratum"
      ],
      correctAnswer: 3
    },
    {
      id: 90114,
      question: "Which infectious lesion commonly appears as redness and cracking at the corners of the mouth in denture wearers?",
      options: [
        "Traumatic ulcer",
        "Epulis fissuratum",
        "Fibrous hyperplasia",
        "Angular cheilitis"
      ],
      correctAnswer: 3
    },
    {
      id: 90115,
      question: "Which infectious lesion often presents as redness under the palatal area covered by a denture?",
      options: [
        "Traumatic ulcer",
        "Epulis fissuratum",
        "Chronic candidiasis",
        "Fibrous hyperplasia"
      ],
      correctAnswer: 2
    },
    {
      id: 90116,
      question: "Denture-induced papillary hyperplasia is classified under which mucosal lesion category?",
      options: [
        "Mixed reactive and infectious",
        "Purely traumatic",
        "Purely genetic",
        "Purely infectious"
      ],
      correctAnswer: 0
    },
    {
      id: 90117,
      question: "Why is regular professional assessment of oral tissues important for denture wearers?",
      options: [
        "Professional visits are only needed for cleaning",
        "Denture wearers cannot develop oral lesions",
        "Denture irritation may be a co-carcinogenic factor in predisposed individuals",
        "Dentures never require reassessment once fitted"
      ],
      correctAnswer: 2
    },
    {
      id: 90118,
      question: "What commonly happens to nutritional status when a prosthesis is ill-fitting?",
      options: [
        "Nutritional status may suffer because eating becomes less pleasurable",
        "Nutritional status always improves",
        "Fiber intake automatically increases",
        "Protein intake automatically increases"
      ],
      correctAnswer: 0
    },
    {
      id: 90119,
      question: "Which dietary tendency is common among aged edentulous individuals?",
      options: [
        "Preference for raw, fibrous vegetables",
        "Preference for a soft diet high in carbohydrate and refined sugar",
        "Preference for tough, chewy meats",
        "Preference for high-fiber, protein-rich foods"
      ],
      correctAnswer: 1
    },
    {
      id: 90120,
      question: "How can xerostomia combined with denture wear affect food choices?",
      options: [
        "Clients chew more vigorously without issue",
        "Clients may avoid foods requiring a lot of chewing due to friction and dry mouth",
        "Saliva production increases to compensate",
        "Food choices remain completely unaffected"
      ],
      correctAnswer: 1
    },
    {
      id: 90121,
      question: "Which type of denture cleanser dissolves mucins and organic substances but can corrode metal?",
      options: [
        "Ultrasonic cleaning devices",
        "Alkaline hypochlorite",
        "Microwave radiation",
        "Chlorhexidine gluconate solution"
      ],
      correctAnswer: 1
    },
    {
      id: 90122,
      question: "Which antimicrobial denture cleansing method uses electromagnetic waves and is intended for in-office use only?",
      options: [
        "Microwave radiation",
        "Alkaline peroxide",
        "Chlorhexidine gluconate solution",
        "Alkaline hypochlorite"
      ],
      correctAnswer: 0
    },
    {
      id: 90123,
      question: "Which denture cleanser is antibacterial and antifungal but may stain denture teeth and only temporarily relieves denture stomatitis symptoms?",
      options: [
        "Chlorhexidine gluconate solution",
        "Microwave radiation",
        "Ultrasonic cleaning devices",
        "Alkaline hypochlorite"
      ],
      correctAnswer: 0
    },
    {
      id: 90124,
      question: "The decline in edentulousness has been one of the most significant changes in older adults' oral status over the last century.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90125,
      question: "According to the presented model, alveolar bone resorption occurs because of increased downward pressure after tooth loss.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90126,
      question: "Oral pilocarpine for Sjogren's-related xerostomia is typically dosed once daily at 50 mg.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90127,
      question: "Aged edentulous individuals commonly show a dietary tendency toward more protein-rich and high-fiber foods.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "2. The Oral Cavity and Aging (Part 2)": [
    {
      id: 90128,
      question: "What percentage of adults aged 65 years or older have gum disease?",
      options: [
        "68%",
        "46%",
        "25%",
        "14%"
      ],
      correctAnswer: 0
    },
    {
      id: 90129,
      question: "What proportion of older adults have untreated tooth decay?",
      options: [
        "1 in 10",
        "1 in 5",
        "1 in 3",
        "1 in 2"
      ],
      correctAnswer: 1
    },
    {
      id: 90130,
      question: "Approximately what proportion of adults aged 65 or older have lost all of their natural teeth?",
      options: [
        "1 in 10",
        "1 in 3",
        "1 in 5",
        "1 in 4"
      ],
      correctAnswer: 2
    },
    {
      id: 90131,
      question: "What percentage of elders actually visit the dentist?",
      options: [
        "70%",
        "25%",
        "90%",
        "46%"
      ],
      correctAnswer: 3
    },
    {
      id: 90132,
      question: "What percentage of elders lack dental insurance?",
      options: [
        "70%",
        "46%",
        "25%",
        "90%"
      ],
      correctAnswer: 0
    },
    {
      id: 90133,
      question: "Approximately how many elders reside in nursing facilities?",
      options: [
        "500,000",
        "1.5 million",
        "3 million",
        "6.6 million"
      ],
      correctAnswer: 1
    },
    {
      id: 90134,
      question: "What percentage of nursing facility residents cannot brush their own teeth or care for their dentures?",
      options: [
        "16%",
        "46%",
        "70-90%",
        "25%"
      ],
      correctAnswer: 2
    },
    {
      id: 90135,
      question: "In nursing facilities, what percentage of residents receive any oral care, with an average brushing time of only 16 seconds?",
      options: [
        "46%",
        "68%",
        "25%",
        "16%"
      ],
      correctAnswer: 3
    },
    {
      id: 90136,
      question: "Approximately how many elders are considered \"near poor\" or poor?",
      options: [
        "6.6 million",
        "1.5 million",
        "9,500",
        "49,000"
      ],
      correctAnswer: 0
    },
    {
      id: 90137,
      question: "What percentage of adults over 65 live in rural communities?",
      options: [
        "25%",
        "14%",
        "46%",
        "70%"
      ],
      correctAnswer: 1
    },
    {
      id: 90138,
      question: "Which condition commonly results from tooth loss and poorly fitting dentures causing creasing of the skin at the corners of the mouth?",
      options: [
        "Leukoplakia",
        "Denture stomatitis",
        "Angular cheilitis",
        "Erythroplakia"
      ],
      correctAnswer: 2
    },
    {
      id: 90139,
      question: "Which of the following is the most common risk factor for denture stomatitis?",
      options: [
        "Xerostomia",
        "Nutritional deficiency",
        "Diabetes",
        "Continuous denture wear"
      ],
      correctAnswer: 3
    },
    {
      id: 90140,
      question: "How should dentures be brushed to avoid damaging the denture material?",
      options: [
        "Liquid hand soap, dishwashing liquid, or denture cleaning paste",
        "Regular toothpaste and a hard-bristle brush",
        "Bleach-based cleaning solution",
        "Alcohol-based mouthwash"
      ],
      correctAnswer: 0
    },
    {
      id: 90141,
      question: "For how many hours should dentures be removed from the mouth each night?",
      options: [
        "About 2 hours",
        "At least 8 hours",
        "About 4 hours",
        "About 12 hours"
      ],
      correctAnswer: 1
    },
    {
      id: 90142,
      question: "Which organism is most often implicated in the etiology of denture stomatitis?",
      options: [
        "Streptococcus",
        "Staphylococcus",
        "Candida",
        "E. coli"
      ],
      correctAnswer: 2
    },
    {
      id: 90143,
      question: "Which type of dental caries is especially common in the elderly due to gingival recession exposing the tooth root?",
      options: [
        "Pit and fissure caries",
        "Interproximal caries",
        "Rampant caries",
        "Root caries"
      ],
      correctAnswer: 3
    },
    {
      id: 90144,
      question: "Which of the following is NOT listed as a risk factor for caries in elderly patients?",
      options: [
        "High level of physical activity",
        "Xerostomia",
        "Low socioeconomic status",
        "Inadequate fluoride exposure"
      ],
      correctAnswer: 0
    },
    {
      id: 90145,
      question: "Which off-label topical treatment arrests carious lesions within 2 years in 91% of patients and is useful for patients with cognitive or physical limitations?",
      options: [
        "Fluoride varnish alone",
        "Silver diamine fluoride",
        "Root canal therapy",
        "Chlorhexidine rinse"
      ],
      correctAnswer: 1
    },
    {
      id: 90146,
      question: "What differentiates gingivitis from periodontitis?",
      options: [
        "Gingivitis involves loss of supporting bone",
        "Periodontitis shows no bleeding",
        "Gingivitis has no destruction of the periodontal ligament or bone",
        "Periodontitis is fully reversible"
      ],
      correctAnswer: 2
    },
    {
      id: 90147,
      question: "What is a caution associated with using chlorhexidine to treat periodontitis?",
      options: [
        "It whitens the teeth over time",
        "It cures active caries lesions",
        "It increases salivary flow",
        "It may stain teeth yellow to brown"
      ],
      correctAnswer: 3
    },
    {
      id: 90148,
      question: "Leukoplakia (\"white patch\") and erythroplakia (\"red patch\") are best described as:",
      options: [
        "Premalignant conditions",
        "Benign and completely harmless",
        "Signs of vitamin deficiency",
        "Normal age-related changes"
      ],
      correctAnswer: 0
    },
    {
      id: 90149,
      question: "How long should an unexplained white lesion persist before it should be biopsied?",
      options: [
        "1 week",
        "2 weeks",
        "1 month",
        "6 weeks"
      ],
      correctAnswer: 1
    },
    {
      id: 90150,
      question: "Oral cancer accounts for approximately what percentage of all cancers in the US?",
      options: [
        "10%",
        "25%",
        "4%",
        "50%"
      ],
      correctAnswer: 2
    },
    {
      id: 90151,
      question: "Which virus is associated with an increased risk of oral cancer?",
      options: [
        "HIV",
        "Hepatitis B",
        "Epstein-Barr virus",
        "Human Papilloma Virus (HPV 16)"
      ],
      correctAnswer: 3
    },
    {
      id: 90152,
      question: "What is the approximate 5-year survival rate for oral cancer?",
      options: [
        "50%",
        "25%",
        "75%",
        "90%"
      ],
      correctAnswer: 0
    },
    {
      id: 90153,
      question: "Which class of medications is most commonly associated with causing xerostomia?",
      options: [
        "Antibiotics and antivirals",
        "Antihypertensives, antidepressants, antihistamines, diuretics",
        "Vitamins and supplements",
        "Topical antifungal agents"
      ],
      correctAnswer: 1
    },
    {
      id: 90154,
      question: "What is the most important natural protective factor against dental caries that is reduced in xerostomia?",
      options: [
        "Fluoride toothpaste",
        "Enamel thickness",
        "Saliva",
        "Vitamin C intake"
      ],
      correctAnswer: 2
    },
    {
      id: 90155,
      question: "Which concentration of topical fluoride is recommended for patients at high caries risk, such as those with xerostomia?",
      options: [
        "0.05% sodium fluoride",
        "0.5% sodium fluoride",
        "2.2% sodium fluoride",
        "1.1% sodium fluoride"
      ],
      correctAnswer: 3
    },
    {
      id: 90156,
      question: "Which medications are commonly associated with gingival overgrowth?",
      options: [
        "Phenytoin, methotrexate, calcium channel blockers",
        "Antibiotics such as amoxicillin",
        "NSAIDs like ibuprofen",
        "Statins for cholesterol"
      ],
      correctAnswer: 0
    },
    {
      id: 90157,
      question: "IV bisphosphonates are associated with which serious oral complication?",
      options: [
        "Dental caries",
        "Osteonecrosis of the jaw",
        "Gingival overgrowth",
        "Dry mouth (xerostomia)"
      ],
      correctAnswer: 1
    },
    {
      id: 90158,
      question: "What is the estimated prevalence of bisphosphonate-related osteonecrosis of the jaw?",
      options: [
        "5%",
        "25%",
        "0.1%",
        "50%"
      ],
      correctAnswer: 2
    },
    {
      id: 90159,
      question: "The relationship between diabetes and periodontal disease is best described as:",
      options: [
        "No known connection at all",
        "A one-way relationship only",
        "A relationship limited to children",
        "A vicious, bidirectional cycle"
      ],
      correctAnswer: 3
    },
    {
      id: 90160,
      question: "Treating periodontal disease can result in approximately what improvement in glycemic control?",
      options: [
        "10-20%",
        "1-2%",
        "50%",
        "90%"
      ],
      correctAnswer: 0
    },
    {
      id: 90161,
      question: "Oral care protocol interventions have been shown to reduce ventilator-associated pneumonia by approximately what percentage?",
      options: [
        "25%",
        "89.7%",
        "50%",
        "16%"
      ],
      correctAnswer: 1
    },
    {
      id: 90162,
      question: "Which of the following medical conditions requires antibiotic prophylaxis prior to certain dental procedures according to the 2017 AHA update?",
      options: [
        "Prosthetic joint implants",
        "Well-controlled type 2 diabetes",
        "Previous infective endocarditis",
        "Well-controlled hypertension"
      ],
      correctAnswer: 2
    },
    {
      id: 90163,
      question: "What INR range is generally considered acceptable for most dental procedures without interrupting anticoagulation?",
      options: [
        "1.0-1.5",
        "4.0-5.0",
        "0.5-1.0",
        "1.8-3.5"
      ],
      correctAnswer: 3
    },
    {
      id: 90164,
      question: "A thorough oral assessment should include palpation of which structures?",
      options: [
        "Neck, temporomandibular joint, and floor of the mouth",
        "Only the visible teeth",
        "Only the tongue surface",
        "Only the lips"
      ],
      correctAnswer: 0
    },
    {
      id: 90165,
      question: "What is the average number of remaining natural teeth in adults over age 65?",
      options: [
        "10",
        "18",
        "24",
        "32"
      ],
      correctAnswer: 1
    },
    {
      id: 90166,
      question: "What percentage of adults over 65 are completely edentulous (have no natural teeth)?",
      options: [
        "10%",
        "46%",
        "25%",
        "70%"
      ],
      correctAnswer: 2
    },
    {
      id: 90167,
      question: "Which of the following is a known oral complication after a stroke, involving poor clearance of food from the mouth?",
      options: [
        "Increased salivary flow",
        "Improved tongue mobility",
        "Enhanced taste sensation",
        "Increased food packing"
      ],
      correctAnswer: 3
    },
    {
      id: 90168,
      question: "Based on U.S. population projections, how is the number of older adults expected to change from 2015 to 2060?",
      options: [
        "It is projected to more than double",
        "It is projected to decrease steadily",
        "It is projected to remain flat",
        "It is projected to fall by half"
      ],
      correctAnswer: 0
    },
    {
      id: 90169,
      question: "Which of the following is a common oral effect of stroke-related impairment?",
      options: [
        "Improved chewing dexterity",
        "Poor tongue function and lip seal",
        "Increased saliva clearance",
        "Decreased caries risk"
      ],
      correctAnswer: 1
    },
    {
      id: 90170,
      question: "In patients with rheumatoid arthritis, diminished salivary output is often linked to which condition?",
      options: [
        "Osteoporosis",
        "Diabetes mellitus",
        "Sjögren's syndrome",
        "Hypertension"
      ],
      correctAnswer: 2
    },
    {
      id: 90171,
      question: "Which of the following is a contributing factor to poor oral health in patients with dementia?",
      options: [
        "Increased manual dexterity",
        "Improved compliance with hygiene",
        "Enhanced swallowing ability",
        "Resistance to care and self-care deficits"
      ],
      correctAnswer: 3
    },
    {
      id: 90172,
      question: "Taste alteration (dysgeusia) is associated with how many different medications?",
      options: [
        "Over 200",
        "About 10",
        "About 50",
        "Over 1,000"
      ],
      correctAnswer: 0
    },
    {
      id: 90173,
      question: "Which of the following findings during an oral exam might raise concern for elder abuse?",
      options: [
        "Well-fitted dentures",
        "Bruises to the chin or earlobes at varying stages of healing",
        "Normal hydration status",
        "Good oral hygiene"
      ],
      correctAnswer: 1
    },
    {
      id: 90174,
      question: "Oral hygiene protocols in hospitals and nursing facilities can reduce pneumonia incidence and prevent approximately how many pneumonia deaths?",
      options: [
        "1 in 2",
        "1 in 50",
        "1 in 10",
        "1 in 100"
      ],
      correctAnswer: 2
    },
    {
      id: 90175,
      question: "Which finding is often seen on oral examination in a patient with xerostomia?",
      options: [
        "Wet, glistening mucosa with pooled saliva",
        "Excessive salivary pooling",
        "Normal moisture with no changes",
        "Dry and friable mucosa with no pooling of saliva"
      ],
      correctAnswer: 3
    },
    {
      id: 90176,
      question: "Prophylactic antibiotics are generally recommended for patients with prosthetic joint implants prior to dental procedures.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90177,
      question: "Dentures should be removed during an oral examination to properly assess the soft tissue and teeth underneath.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90178,
      question: "Treatment of periodontal disease has been proven to reduce cardiovascular risk.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90179,
      question: "Continuing anticoagulation therapy is generally preferred over discontinuing it for routine dental cleanings, fillings, and simple extractions.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90180,
      question: "Squamous cell carcinoma of the lip is uncommon in older adults and rarely presents as a non-healing lesion.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "3. Process of Care & the Older Adult": [
    {
      id: 90181,
      question: "According to the required readings, which chapter in Darby & Walsh's Dental Hygiene: Theory and Practice covers 'The Older Adult'?",
      options: [
        "Chapter 57",
        "Chapter 55",
        "Chapter 56",
        "Chapter 54"
      ],
      correctAnswer: 1
    },
    {
      id: 90182,
      question: "Which chapter covers 'Persons with Fixed and Removable Dental Prostheses'?",
      options: [
        "Chapter 55",
        "Chapter 56",
        "Chapter 54",
        "Chapter 58"
      ],
      correctAnswer: 1
    },
    {
      id: 90183,
      question: "Where do dental hygienists begin assessing the overall physical factors of an older adult?",
      options: [
        "In the consultation office",
        "In the radiography room",
        "In the sterilization area",
        "In the reception area"
      ],
      correctAnswer: 3
    },
    {
      id: 90184,
      question: "Which of the following is specifically noted as an assessment consideration when observing an older adult upon arrival?",
      options: [
        "Gait and balance",
        "Hand dominance",
        "Shoe size",
        "Hair color"
      ],
      correctAnswer: 0
    },
    {
      id: 90185,
      question: "Besides gait and balance, what other physical transfer situation is specifically mentioned as part of assessment?",
      options: [
        "Stretcher transfer",
        "Car seat transfer",
        "Wheelchair transfer",
        "Elevator transfer"
      ],
      correctAnswer: 2
    },
    {
      id: 90186,
      question: "Which of the following is listed as a factor to consider regarding communication with older clients?",
      options: [
        "Vision and hearing impairments",
        "Preferred appointment day",
        "Handwriting style",
        "Insurance provider"
      ],
      correctAnswer: 0
    },
    {
      id: 90187,
      question: "What should the health history form for an older adult include?",
      options: [
        "Only insurance information",
        "Only current dental complaints",
        "The client's personal, medical, and dental background",
        "Only emergency contact information"
      ],
      correctAnswer: 2
    },
    {
      id: 90188,
      question: "Both prescription and over-the-counter medications must be reviewed for what purpose?",
      options: [
        "Insurance coverage",
        "Appointment scheduling",
        "Oral implications",
        "Billing accuracy"
      ],
      correctAnswer: 2
    },
    {
      id: 90189,
      question: "Which term refers to the use of multiple medications, an important consideration in older adult health history?",
      options: [
        "Comorbidity",
        "Polypharmacy",
        "Monotherapy",
        "Xerostomia"
      ],
      correctAnswer: 1
    },
    {
      id: 90190,
      question: "Reduced muscle tone associated with aging, as noted in the assessment section, is referred to as what?",
      options: [
        "Sarcopenia",
        "Presbyopia",
        "Dysphagia",
        "Osteopenia"
      ],
      correctAnswer: 0
    },
    {
      id: 90191,
      question: "TMJ changes in older adults are associated with which two conditions mentioned in the material?",
      options: [
        "Diabetes and hypertension",
        "Anemia and arthritis",
        "Osteoporosis and osteoarthritis",
        "Asthma and bronchitis"
      ],
      correctAnswer: 2
    },
    {
      id: 90192,
      question: "In addition to muscle tone and TMJ, which two other areas are specifically listed for assessment?",
      options: [
        "Lips, and quantity/quality of saliva",
        "Nails and skin tone",
        "Ears and hearing aids",
        "Hair and scalp condition"
      ],
      correctAnswer: 0
    },
    {
      id: 90193,
      question: "According to the oral cancer self-examination information, what is the estimated survival rate when oral cancer is detected early?",
      options: [
        "95 percent",
        "65 percent",
        "50 percent",
        "80 percent"
      ],
      correctAnswer: 3
    },
    {
      id: 90194,
      question: "What supplies are recommended for the monthly oral cancer self-examination routine?",
      options: [
        "Tongue depressor and mouthwash",
        "Cotton swabs and alcohol wipes",
        "Flashlight, small mirror, piece of gauze, wall mirror",
        "Dental floss and a toothpick"
      ],
      correctAnswer: 2
    },
    {
      id: 90195,
      question: "During a self-examination, what should a person use to help examine all sides of the tongue?",
      options: [
        "A piece of gauze between finger and thumb",
        "A toothbrush",
        "A mouth mirror only",
        "A cotton ball"
      ],
      correctAnswer: 0
    },
    {
      id: 90196,
      question: "Any mouth sore that has not healed after how many days should be reported?",
      options: [
        "7 days",
        "3 days",
        "14 days",
        "30 days"
      ],
      correctAnswer: 2
    },
    {
      id: 90197,
      question: "Why should the older client's nutritional status be evaluated according to the material?",
      options: [
        "Because it determines appointment length only",
        "Because insurance requires it",
        "Because of physiologic and psychosocial complexities documented in dietary patterns for the elderly",
        "Because it is unrelated to oral health"
      ],
      correctAnswer: 2
    },
    {
      id: 90198,
      question: "On the nutritional screening tool shown, a score of 12-14 points indicates what nutritional status?",
      options: [
        "At risk of malnutrition",
        "Malnourished",
        "Severe deficiency",
        "Normal nutritional status"
      ],
      correctAnswer: 3
    },
    {
      id: 90199,
      question: "On the same nutritional screening tool, a score of 0-7 points indicates what status?",
      options: [
        "Overnourished",
        "At risk of malnutrition",
        "Normal nutritional status",
        "Malnourished"
      ],
      correctAnswer: 3
    },
    {
      id: 90200,
      question: "Care planning and implementation for older adults should be based on which of the following factors, according to the material?",
      options: [
        "Only the client's age",
        "Only the client's preferred appointment time",
        "Dental hygiene diagnosis, chronic condition severity, cognitive abilities, self-care level, expectations, and financial ability",
        "Only the client's insurance plan"
      ],
      correctAnswer: 2
    },
    {
      id: 90201,
      question: "What type of appointment scheduling is recommended for older clients along with a stress reduction protocol?",
      options: [
        "Evening appointments only",
        "Short morning appointments",
        "Long afternoon appointments",
        "Weekend-only appointments"
      ],
      correctAnswer: 1
    },
    {
      id: 90202,
      question: "Why is dental hygiene care planning for older adults often more complex than for younger persons?",
      options: [
        "Because older adults require less documentation",
        "Because insurance forms are longer",
        "Because the vast majority have at least one chronic condition and many have complex dental and periodontal conditions",
        "Because appointments are shorter"
      ],
      correctAnswer: 2
    },
    {
      id: 90203,
      question: "According to the planning section, how do many older adults tend to view oral problems?",
      options: [
        "As unrelated to overall health",
        "As an inevitable part of aging",
        "As primarily a cosmetic issue",
        "As a curable condition requiring urgent care"
      ],
      correctAnswer: 1
    },
    {
      id: 90204,
      question: "What does research suggest about how older people perceive their need for dental care?",
      options: [
        "They have no perception of need at all",
        "They perceive a lower need than what is actually required",
        "They perceive the same need as younger adults",
        "They perceive a higher need than what is actually required"
      ],
      correctAnswer: 1
    },
    {
      id: 90205,
      question: "What is identified as a barrier to dental care use for many older adults?",
      options: [
        "Distance to office only",
        "Lack of transportation only",
        "Cost of care",
        "Lack of available appointments"
      ],
      correctAnswer: 2
    },
    {
      id: 90206,
      question: "Why is minimal trauma to the gingiva especially important during instrumentation of older clients?",
      options: [
        "Because of increased pain tolerance",
        "Because their teeth are more sensitive",
        "Because their gingiva is thicker",
        "Because of reduction in healing capabilities"
      ],
      correctAnswer: 3
    },
    {
      id: 90207,
      question: "What two conditions are noted as making retraction of oral tissues uncomfortable in older clients?",
      options: [
        "Loss of elasticity of lips/oral mucosa and xerostomia",
        "Gingival hyperplasia and halitosis",
        "Excess saliva and swelling",
        "Bruxism and malocclusion"
      ],
      correctAnswer: 0
    },
    {
      id: 90208,
      question: "Older adults with a history of periodontal disease need what type of follow-up care?",
      options: [
        "Annual periodontal maintenance only",
        "More-frequent periodontal maintenance therapy",
        "No further periodontal maintenance",
        "Less frequent periodontal maintenance"
      ],
      correctAnswer: 1
    },
    {
      id: 90209,
      question: "Why might scaling be completed by quadrants for older adults?",
      options: [
        "To reduce the cost of treatment",
        "To allow for short appointment times",
        "To simplify billing codes",
        "To avoid using anesthesia"
      ],
      correctAnswer: 1
    },
    {
      id: 90210,
      question: "For clients requiring antibiotic premedication, what is the recommended approach to appointment scheduling, given possible limitations?",
      options: [
        "Schedule only emergency visits",
        "Avoid providing any care until premedication is discontinued",
        "Spread care over many very short visits regardless of medical condition",
        "Complete as much care as possible at one time, though the person's medical condition may make lengthy appointments difficult"
      ],
      correctAnswer: 3
    },
    {
      id: 90211,
      question: "Which of the following is listed as a chemotherapeutic/product option mentioned under implementation?",
      options: [
        "Insulin",
        "Penicillin",
        "Aspirin",
        "Triclosan"
      ],
      correctAnswer: 3
    },
    {
      id: 90212,
      question: "Which product mentioned under implementation contains Novamin?",
      options: [
        "Fluoride varnish",
        "Xylitol gum",
        "Essential oil rinse",
        "MI Paste"
      ],
      correctAnswer: 3
    },
    {
      id: 90213,
      question: "After completing an appointment, how should the dental chair be returned to an upright position?",
      options: [
        "Quickly, to save time",
        "Only after the client stands up",
        "In two abrupt stages",
        "Slowly"
      ],
      correctAnswer: 3
    },
    {
      id: 90214,
      question: "Why should an older client be allowed to sit up for a short time before dismissal from the chair?",
      options: [
        "To avoid problems with postural hypotension",
        "To review insurance paperwork",
        "To allow time for a snack",
        "To wait for a caregiver to arrive"
      ],
      correctAnswer: 0
    },
    {
      id: 90215,
      question: "According to the evaluation section, why do older clients need to be re-evaluated more frequently and carefully?",
      options: [
        "Because insurance requires more frequent visits",
        "Because they request more appointments",
        "Because of the many physiologic changes, chronic conditions, and pathologic changes common in this age group",
        "Because they are less compliant with instructions"
      ],
      correctAnswer: 2
    },
    {
      id: 90216,
      question: "A dental hygienist may often be the first to notice which type of change over a series of appointments with an older client?",
      options: [
        "Cognitive declines",
        "Changes in favorite toothpaste brand",
        "Changes in home address",
        "Changes in insurance coverage"
      ],
      correctAnswer: 0
    },
    {
      id: 90217,
      question: "What quantitative measures are used to document healing and plan new interventions with older clients?",
      options: [
        "Weight and height only",
        "Vision and hearing test scores",
        "Blood pressure and pulse only",
        "Bleeding and plaque indices and pocket depth recording"
      ],
      correctAnswer: 3
    },
    {
      id: 90218,
      question: "In the case of Juan Hernandez (81-year-old male), which medication he takes is an anticoagulant that could increase bleeding risk during instrumentation?",
      options: [
        "Warfarin (Coumadin)",
        "Naproxen (Naproxsyn)",
        "Chlorothiazide (Diuril)",
        "Atorvastatin (Lipitor)"
      ],
      correctAnswer: 0
    },
    {
      id: 90219,
      question: "What is Juan Hernandez proud of regarding his dental history?",
      options: [
        "Having all of his teeth and never needing dentures",
        "Never having a cavity",
        "Having perfect radiographs",
        "Having straight teeth without orthodontics"
      ],
      correctAnswer: 0
    },
    {
      id: 90220,
      question: "What is Juan Hernandez's chief complaint at his visit?",
      options: [
        "Bleeding gums",
        "TMJ stiffness and a bilateral crackling sensation",
        "A broken denture",
        "Severe tooth pain"
      ],
      correctAnswer: 1
    },
    {
      id: 90221,
      question: "In Virginia Carson's case, what habit is identified as a deficit in 'protection from health risks'?",
      options: [
        "Overuse of mouthwash",
        "Tobacco usage",
        "Excessive flossing",
        "Frequent snacking"
      ],
      correctAnswer: 1
    },
    {
      id: 90222,
      question: "What dental appliance issue prompted Virginia Carson's dental hygiene appointment?",
      options: [
        "A missing crown",
        "A fractured ten-year-old partial denture and a new ill-fitting full maxillary denture",
        "A broken dental implant",
        "An orthodontic retainer that no longer fits"
      ],
      correctAnswer: 1
    },
    {
      id: 90223,
      question: "In Eleanor Gray's case, which of her medications creates a risk of osteonecrosis of the jaw, identified as a deficit in 'protection from health risks'?",
      options: [
        "Alendronate sodium (Fosamax)",
        "Donepezil (Aricept)",
        "Risperidone (Risperdal)",
        "Calcium carbonate supplement"
      ],
      correctAnswer: 0
    },
    {
      id: 90224,
      question: "What medical condition is Eleanor Gray being screened for participation in a clinical trial related to?",
      options: [
        "Alzheimer's disease progression",
        "Osteoporosis",
        "Congestive heart failure",
        "Chronic obstructive pulmonary disease"
      ],
      correctAnswer: 0
    },
    {
      id: 90225,
      question: "What behavior did Eleanor Gray display during her last dental visit that is noted as a deficit in 'freedom from fear and stress'?",
      options: [
        "She requested extra fluoride treatments",
        "She fell asleep during treatment",
        "She asked to reschedule for a shorter visit",
        "She became disruptive and refused treatment"
      ],
      correctAnswer: 3
    },
    {
      id: 90226,
      question: "Dental hygienists should generally attempt to completely change an older client's long-term home care habits rather than modify them.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90227,
      question: "Normal aging alterations may create a compromised oral situation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90228,
      question: "Individuals who receive antibiotic premedication should have care spread across many extra visits rather than as much care as possible at one time.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90229,
      question: "A dental hygienist's qualitative perception that 'something is not quite right' about an older client's cognition should be discussed with the client, relatives, and/or caregivers, with referral for further medical evaluation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90230,
      question: "In Virginia Carson's case, her physician's office noted she has halitosis and recommended she make a dental hygiene appointment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "4. Dental Care for Seniors": [
    {
      id: 90231,
      question: "What is the main goal of primary prevention in elderly care?",
      options: [
        "To stop disease before it begins by reducing risk factors",
        "To detect disease early before symptoms appear",
        "To manage disability once it has already occurred",
        "To treat an existing chronic disease and prevent further decline"
      ],
      correctAnswer: 0
    },
    {
      id: 90232,
      question: "Secondary prevention is best described as which of the following?",
      options: [
        "Providing hospice care during a terminal illness",
        "Managing a chronic disease to prevent further functional loss",
        "Reducing risk factors before any disease develops",
        "Detecting and treating disease early, before symptoms occur"
      ],
      correctAnswer: 3
    },
    {
      id: 90233,
      question: "Tertiary prevention primarily involves which approach?",
      options: [
        "Giving vaccinations to avoid disease onset",
        "Removing risk factors before disease appears",
        "Screening asymptomatic people for early disease",
        "Appropriately managing an existing chronic disease to prevent further loss"
      ],
      correctAnswer: 3
    },
    {
      id: 90234,
      question: "According to the material, screening can serve which dual purpose?",
      options: [
        "Only to measure a patient's overall fitness level",
        "To replace the need for any further preventive care",
        "To detect risk factors or to find disease in asymptomatic people",
        "Only to confirm a diagnosis after symptoms appear"
      ],
      correctAnswer: 2
    },
    {
      id: 90235,
      question: "Prevention efforts for the elderly mainly focus on which set of concerns?",
      options: [
        "Only chronic disease and nothing else",
        "Disease, frailty, accidents, iatrogenic complications, and psychosocial problems",
        "Only accident prevention in the home",
        "Only psychosocial and emotional concerns"
      ],
      correctAnswer: 1
    },
    {
      id: 90236,
      question: "For healthy elderly people with minimal chronic disease, which prevention is most beneficial?",
      options: [
        "Hospice and palliative planning only",
        "Primary and secondary prevention of disease and prevention of frailty",
        "Prevention of iatrogenic complications only",
        "Tertiary prevention of disease only"
      ],
      correctAnswer: 1
    },
    {
      id: 90237,
      question: "For chronically ill elderly patients, which preventive priorities are emphasized?",
      options: [
        "Only primary prevention of new diseases",
        "Secondary, tertiary, and iatrogenic prevention",
        "Only psychosocial support programs",
        "Only prevention of driving accidents"
      ],
      correctAnswer: 1
    },
    {
      id: 90238,
      question: "For frail or complex elderly patients, which type of prevention is most important?",
      options: [
        "Weight training for bone density",
        "Screening for early-stage disease only",
        "Prevention of accidents and iatrogenic complications",
        "Primary prevention of new chronic diseases"
      ],
      correctAnswer: 2
    },
    {
      id: 90239,
      question: "Which vaccinations are described as effective, inexpensive, and low in morbidity for the elderly?",
      options: [
        "Only annual pneumococcal vaccination",
        "Neither influenza nor pneumococcal vaccination",
        "Only a one-time influenza vaccination",
        "Yearly influenza and one-time pneumococcal vaccines"
      ],
      correctAnswer: 3
    },
    {
      id: 90240,
      question: "What does disease-specific care management involve?",
      options: [
        "A pharmacist reviewing medications independently",
        "A specially trained nurse coordinating protocol-driven care with a physician",
        "A hospital ward dedicated to surgical recovery",
        "A social worker managing housing arrangements"
      ],
      correctAnswer: 1
    },
    {
      id: 90241,
      question: "What is a key feature of chronic care clinics?",
      options: [
        "Patients with the same chronic disease are taught in groups and visited by a practitioner",
        "Patients are treated individually by a specialist only",
        "Patients receive care exclusively through home visits",
        "Patients are admitted for long-term hospitalization"
      ],
      correctAnswer: 0
    },
    {
      id: 90242,
      question: "When does referral to a specialist work best for a difficult-to-stabilize chronic disease?",
      options: [
        "When the specialist and primary care physician work collaboratively",
        "When the specialist manages care without informing the primary physician",
        "When the patient chooses to stop seeing the primary care physician",
        "When only diagnostic tests are needed, not treatment"
      ],
      correctAnswer: 0
    },
    {
      id: 90243,
      question: "Arthritis in the elderly increases the risk of which combination of problems?",
      options: [
        "Only medication side effects",
        "Only vision loss and hearing decline",
        "Osteoporosis, deconditioning, falls, and pressure ulcers",
        "Only depression and social isolation"
      ],
      correctAnswer: 2
    },
    {
      id: 90244,
      question: "How can osteoporosis progression be helped to prevent in older adults?",
      options: [
        "Relying solely on pain medication",
        "Increasing caffeine and reducing dairy intake",
        "Avoiding all forms of physical activity",
        "Bone density testing, calcium/vitamin D, exercise, and smoking cessation"
      ],
      correctAnswer: 3
    },
    {
      id: 90245,
      question: "What happens when the body's insulin does not work properly?",
      options: [
        "Glucose cannot enter cells and blood glucose levels rise",
        "The liver stops producing glucose entirely",
        "Muscle cells absorb glucose more efficiently",
        "Blood glucose levels drop dangerously low"
      ],
      correctAnswer: 0
    },
    {
      id: 90246,
      question: "For diabetic elderly patients, controlling which conditions is particularly important?",
      options: [
        "Only blood pressure, not cholesterol",
        "Vitamin D and calcium levels only",
        "Hypertension and dyslipidemia",
        "Only cholesterol, not blood pressure"
      ],
      correctAnswer: 2
    },
    {
      id: 90247,
      question: "How can risk from vascular disorders be reduced in elderly patients?",
      options: [
        "Limiting fluid intake only",
        "Avoiding all forms of medical treatment",
        "Focusing solely on dietary fiber intake",
        "Aggressively managing hypertension, smoking, and diabetes"
      ],
      correctAnswer: 3
    },
    {
      id: 90248,
      question: "Why is heart failure considered significant among the elderly?",
      options: [
        "Its mortality rate is higher than that of many cancers",
        "It has no effect on hospitalization rates",
        "It is easily cured with a single medication",
        "It rarely affects functional ability"
      ],
      correctAnswer: 0
    },
    {
      id: 90249,
      question: "Which strategies help decrease COPD exacerbations leading to hospitalization?",
      options: [
        "Smoking cessation, proper inhaler use, and energy-conserving education",
        "Avoiding all forms of patient education",
        "Increasing physical exertion without restriction",
        "Discontinuing all respiratory medications"
      ],
      correctAnswer: 0
    },
    {
      id: 90250,
      question: "Frailty is best defined as which of the following?",
      options: [
        "A permanent and irreversible cognitive decline",
        "An acute infection common in hospitals",
        "A specific chronic disease affecting only the lungs",
        "Loss of physiologic reserve, causing disability from minor stress"
      ],
      correctAnswer: 3
    },
    {
      id: 90251,
      question: "What lifestyle approach is recommended to prevent or reduce frailty?",
      options: [
        "Complete bed rest and minimal activity",
        "Regular aerobic exercise and a healthy diet",
        "A high-sugar, high-fat diet for energy",
        "Avoiding all forms of social interaction"
      ],
      correctAnswer: 1
    },
    {
      id: 90252,
      question: "What benefit does weight training provide for elderly people?",
      options: [
        "It has no measurable effect on bone health",
        "It increases bone mass and reduces risk of falls and fractures",
        "It increases risk of fractures over time",
        "It only benefits cardiovascular endurance"
      ],
      correctAnswer: 1
    },
    {
      id: 90253,
      question: "What should a falls prevention program include for high-risk elderly patients?",
      options: [
        "Only medication adjustments",
        "Complete restriction of all movement",
        "Exercise and vitamin D supplementation",
        "Only home relocation to a nursing home"
      ],
      correctAnswer: 2
    },
    {
      id: 90254,
      question: "Which conditions should prompt further assessment of an elderly person's driving ability?",
      options: [
        "Only a recent traffic ticket",
        "Only age above 65 with no other factors",
        "Only occasional difficulty parking",
        "Poor vision, dementia, impaired movement, and poor coordination"
      ],
      correctAnswer: 3
    },
    {
      id: 90255,
      question: "What hot water heater temperature helps prevent burns in elderly people with neuropathy?",
      options: [
        "Below 49°C",
        "Above 70°C",
        "Exactly 60°C",
        "There is no recommended temperature limit"
      ],
      correctAnswer: 0
    },
    {
      id: 90256,
      question: "Which factor increases the risk that treating one disease will worsen another in the elderly?",
      options: [
        "Having multiple chronic diseases at the same time",
        "Having only one mild chronic condition",
        "Living independently at home",
        "Attending regular exercise classes"
      ],
      correctAnswer: 0
    },
    {
      id: 90257,
      question: "What risk is associated with elderly patients seeing multiple physicians?",
      options: [
        "Elimination of iatrogenic complications",
        "Improved communication between all providers automatically",
        "Reduced need for medication management",
        "Uncoordinated care and polypharmacy"
      ],
      correctAnswer: 3
    },
    {
      id: 90258,
      question: "Which group of patients is at particularly high risk of adverse drug-drug or drug-disease interactions?",
      options: [
        "Patients who are undernourished or have renal failure",
        "Patients who live in assisted living facilities",
        "Patients who exercise regularly",
        "Patients who take no medications"
      ],
      correctAnswer: 0
    },
    {
      id: 90259,
      question: "Which patients are at high risk of iatrogenic complications during hospitalization?",
      options: [
        "Those who avoid all forms of surgery",
        "Those who are admitted for routine check-ups only",
        "Those who are discharged within a few hours",
        "Those with dementia or who are immobilized after surgery"
      ],
      correctAnswer: 3
    },
    {
      id: 90260,
      question: "Which of the following is an example of a medical-technology-related iatrogenic complication?",
      options: [
        "Improved mobility after physical therapy",
        "Stroke after carotid endarterectomy",
        "Reduced infection risk after vaccination",
        "Faster recovery after minor surgery"
      ],
      correctAnswer: 1
    },
    {
      id: 90261,
      question: "What is the role of a care manager in preventing iatrogenic complications?",
      options: [
        "Coordinating communication and preventing duplicated services",
        "Replacing the need for a primary care physician",
        "Performing surgery on complex cases",
        "Prescribing medications without physician input"
      ],
      correctAnswer: 0
    },
    {
      id: 90262,
      question: "When is a geriatric interdisciplinary team best reserved for use?",
      options: [
        "Only for patients with no chronic diseases",
        "For every elderly patient regardless of condition",
        "For very complex cases, since the intervention is resource-intensive",
        "Only for patients who are hospitalized briefly"
      ],
      correctAnswer: 2
    },
    {
      id: 90263,
      question: "What is the purpose of Acute Care for the Elderly (ACE) units?",
      options: [
        "To provide only long-term nursing home placement",
        "To evaluate elderly patients for potential iatrogenic problems before they occur",
        "To focus exclusively on surgical recovery",
        "To eliminate the need for advance directives"
      ],
      correctAnswer: 1
    },
    {
      id: 90264,
      question: "What is the main purpose of advance directives?",
      options: [
        "To assign a new primary care physician automatically",
        "To guarantee a patient will recover from illness",
        "To help prevent unwanted treatment for patients who cannot speak for themselves",
        "To replace the need for a care manager"
      ],
      correctAnswer: 2
    },
    {
      id: 90265,
      question: "Why is depression screening recommended for elderly patients?",
      options: [
        "Depression has no link to physical health",
        "Screening always requires a physician to administer",
        "Depression is common among the elderly and screening is relatively easy",
        "Depression rarely occurs in older adults"
      ],
      correctAnswer: 2
    },
    {
      id: 90266,
      question: "When does eldercare typically become necessary?",
      options: [
        "Only after a person is hospitalized",
        "Only when family members request it",
        "As soon as a person reaches a certain age",
        "When elders find it difficult to safely perform activities of daily living"
      ],
      correctAnswer: 3
    },
    {
      id: 90267,
      question: "How do static conditions like stroke typically differ from progressive conditions?",
      options: [
        "Static conditions always worsen over time",
        "Progressive conditions never affect daily functioning",
        "Static conditions are one-time events, while progressive conditions worsen over time",
        "There is no meaningful difference between them"
      ],
      correctAnswer: 2
    },
    {
      id: 90268,
      question: "What outcome is associated with effective multidisciplinary teamwork in patient care?",
      options: [
        "Increased conflict among care providers",
        "Slower decision-making with no added benefit",
        "Higher quality patient care and more innovation in treatment",
        "Reduced communication among professionals"
      ],
      correctAnswer: 2
    },
    {
      id: 90269,
      question: "What is a limitation of Telephone Call Assurance services for seniors?",
      options: [
        "They may not provide access to immediate medical attention",
        "They always include in-person medical checkups",
        "They require the senior to leave their home",
        "They cannot be scheduled or adjusted"
      ],
      correctAnswer: 0
    },
    {
      id: 90270,
      question: "What is a key concern when hiring companions or caregivers for seniors?",
      options: [
        "Ensuring they replace the senior's primary physician",
        "Ensuring they have no criminal record and are trustworthy",
        "Ensuring they only work night shifts",
        "Ensuring they provide medical diagnoses"
      ],
      correctAnswer: 1
    },
    {
      id: 90271,
      question: "What service do visiting nurses typically provide?",
      options: [
        "Medical care, rehabilitation, and hospice services in the patient's home",
        "Only transportation to appointments",
        "Only social companionship with no medical duties",
        "Only housekeeping and meal preparation"
      ],
      correctAnswer: 0
    },
    {
      id: 90272,
      question: "What is a notable drawback of Continuing Care Retirement Communities (CCRCs)?",
      options: [
        "They provide no long-term peace of mind",
        "They never offer a range of housing options",
        "They require seniors to move to a hospital",
        "They are usually expensive, even if extra care is never needed"
      ],
      correctAnswer: 3
    },
    {
      id: 90273,
      question: "What defines an Assisted Living Facility or Congregate Housing?",
      options: [
        "It focuses exclusively on rehabilitation after surgery",
        "It allows continued independence while providing some care and shared meals",
        "It requires seniors to live completely alone with no services",
        "It provides only full-time hospital-level medical care"
      ],
      correctAnswer: 1
    },
    {
      id: 90274,
      question: "What is a common concern associated with Long Term Care Homes (nursing homes)?",
      options: [
        "They provide no access to physicians or nurses",
        "They are always less expensive than home care",
        "Some seniors find them depressing, and care quality must be monitored",
        "They never have waiting lists for admission"
      ],
      correctAnswer: 2
    },
    {
      id: 90275,
      question: "How does OHIP typically cover dental care for seniors in Ontario?",
      options: [
        "It only covers dental care for seniors under age 65",
        "It covers some dental surgery that must be provided in a hospital due to medical necessity",
        "It provides no dental coverage under any circumstances",
        "It covers all routine dental office visits for every senior"
      ],
      correctAnswer: 1
    },
    {
      id: 90276,
      question: "Choice of preventive measures for elderly patients is guided by the patient's general condition, such as being healthy, chronically ill, or frail/complex.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90277,
      question: "Elderly people who engage in regular aerobic exercise generally show less functional decline than those who are sedentary.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90278,
      question: "Having multiple physicians always improves coordination of care for elderly patients.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90279,
      question: "Some municipalities in Ontario provide financial assistance for low-income seniors to help cover the cost of dental care.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90280,
      question: "According to the material, frailty and aging itself always require an elderly person to lose their independence.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ]
};
